import { OnboardingStep } from 'root/src/client/v2/onboarding/components/OnboardingStep';
export const DROPS_ONBOARDING_STEPS = (drops) => {
    return [
        ...drops.map((drop) => {
            return {
                action: () => {
                    window.location.hash = `#drop=${drop.mnemonicId}`;
                },
                selector: `a[data-mnemonic-id=${drop.mnemonicId}]`,
                resizeObservables: [`a[data-mnemonic-id=${drop.mnemonicId}]`, '.CreatorOnboardingProgressBar'],
                content: (<OnboardingStep key={drop.mnemonicId} disableArrows>
						<div className="text-black">
							<p className="text-black font-medium text-lg">Check Out Games and Rewards</p>
							<p className="text-black opacity-60">Check out the latest or upcoming Drops! Click to see what you need to do</p>
						</div>
					</OnboardingStep>),
            };
        }),
        // PLACEHOLDER
        {},
        {},
        {},
    ];
};
